export const categories = [
  { slug: "all", name: "全部漫画", icon: "ri-global-line" },
  { slug: "hanman", name: "韩漫", icon: "ri-kakao-talk-fill" },
  { slug: "riman", name: "日漫", icon: "ri-sun-fill" },
  { slug: "guoman", name: "国漫", icon: "ri-china-railway-fill" },
  { slug: "rexue", name: "热血", icon: "ri-fire-fill" },
  { slug: "lianai", name: "恋爱", icon: "ri-heart-fill" },
  { slug: "gaoxiao", name: "搞笑", icon: "ri-emotion-laugh-fill" },
  { slug: "xuanyi", name: "悬疑", icon: "ri-search-eye-line" },
  { slug: "wanjie", name: "已完结", icon: "ri-check-double-fill" },
  { slug: "lianzai", name: "连载中", icon: "ri-loader-4-fill" },
];

export const comics = [
  {
    id: 1,
    title: "霸道总裁的契约新娘",
    author: "金秀雅",
    category: "hanman",
    subCategory: "lianai",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20romantic%20Korean%20manhwa%20style%20comic%20cover%20featuring%20an%20elegant%20woman%20and%20a%20handsome%20man%20in%20a%20soft%20embrace%2C%20soft%20pastel%20colors%2C%20cherry%20blossom%20petals%20floating%2C%20clean%20white%20background%20with%20subtle%20pink%20gradient%2C%20manga%20cover%20art%20style%2C%20delicate%20linework%2C%20romantic%20atmosphere&width=400&height=560&seq=comic-cover-01&orientation=portrait",
    rating: 9.5,
    views: 1283900,
    status: "连载中",
    updateTime: "2小时前",
    latestChapter: "第89话",
    description: "为了拯救家族企业，她不得不嫁给那个冷酷无情的商业帝王。原以为是一场没有爱情的商业联姻，却没想到，那个男人在婚后展现出了截然不同的一面...",
    tags: ["韩漫", "恋爱", "总裁", "契约婚姻"],
    chapters: [
      { num: 89, title: "他的真心", date: "2026-08-04" },
      { num: 88, title: "意外的拥抱", date: "2026-08-01" },
      { num: 87, title: "深夜的短信", date: "2026-07-30" },
      { num: 86, title: "危机降临", date: "2026-07-27" },
      { num: 85, title: "她的选择", date: "2026-07-24" },
    ],
  },
  {
    id: 2,
    title: "重生之绝世剑神",
    author: "林风",
    category: "guoman",
    subCategory: "rexue",
    cover: "https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20comic%20cover%20featuring%20a%20powerful%20swordsman%20with%20flowing%20long%20hair%20holding%20a%20glowing%20sword%2C%20dramatic%20martial%20arts%20pose%2C%20golden%20energy%20aura%20surrounding%20him%2C%20ancient%20Chinese%20fantasy%20setting%20with%20misty%20mountains%20in%20background%2C%20vibrant%20red%20and%20gold%20color%20scheme%2C%20clean%20composition%2C%20epic%20atmosphere&width=400&height=560&seq=comic-cover-02&orientation=portrait",
    rating: 9.7,
    views: 2560000,
    status: "连载中",
    updateTime: "5小时前",
    latestChapter: "第156话",
    description: "一代剑神惨遭背叛，陨落之后意外重生回到少年时代。这一世，他带着前世的记忆和剑道感悟，誓要踏平所有敌人，登顶武道巅峰！",
    tags: ["国漫", "热血", "重生", "修仙"],
    chapters: [
      { num: 156, title: "剑道巅峰", date: "2026-08-04" },
      { num: 155, title: "破境之战", date: "2026-08-02" },
      { num: 154, title: "天劫降临", date: "2026-07-31" },
      { num: 153, title: "最后的准备", date: "2026-07-28" },
      { num: 152, title: "强敌来袭", date: "2026-07-25" },
    ],
  },
  {
    id: 3,
    title: "办公室的秘密关系",
    author: "崔智恩",
    category: "hanman",
    subCategory: "lianai",
    cover: "https://readdy.ai/api/search-image?query=A%20mature%20romance%20manhwa%20cover%20style%20showing%20a%20beautiful%20office%20lady%20in%20elegant%20business%20attire%20and%20a%20handsome%20man%20in%20a%20suit%2C%20subtle%20attraction%20between%20them%2C%20modern%20office%20background%20with%20warm%20lighting%2C%20sophisticated%20color%20palette%20of%20navy%20and%20cream%20tones%2C%20Korean%20webtoon%20art%20style%2C%20clean%20and%20elegant%20composition&width=400&height=560&seq=comic-cover-03&orientation=portrait",
    rating: 9.3,
    views: 985000,
    status: "连载中",
    updateTime: "1天前",
    latestChapter: "第67话",
    description: "她是新入职的普通员工，而他却是公司最年轻的本部长。一场意外让两人产生了交集，从此办公室里的每一次对视都暗藏着不为人知的秘密...",
    tags: ["韩漫", "恋爱", "职场", "姐弟恋"],
    chapters: [
      { num: 67, title: "心跳加速", date: "2026-08-03" },
      { num: 66, title: "电梯里的偶遇", date: "2026-07-31" },
      { num: 65, title: "加班之夜", date: "2026-07-29" },
      { num: 64, title: "他的温柔", date: "2026-07-26" },
      { num: 63, title: "误会加深", date: "2026-07-23" },
    ],
  },
  {
    id: 4,
    title: "搞笑一家人",
    author: "张明浩",
    category: "guoman",
    subCategory: "gaoxiao",
    cover: "https://readdy.ai/api/search-image?query=A%20funny%20comedy%20manhua%20cover%20showing%20a%20chaotic%20Chinese%20family%20with%20exaggerated%20funny%20facial%20expressions%2C%20a%20father%20tripping%20over%20a%20toy%2C%20mother%20looking%20exasperated%2C%20kids%20laughing%20hysterically%2C%20bright%20colorful%20living%20room%20setting%2C%20cartoonish%20exaggerated%20style%2C%20vibrant%20warm%20colors%2C%20lighthearted%20and%20humorous%20atmosphere&width=400&height=560&seq=comic-cover-04&orientation=portrait",
    rating: 9.1,
    views: 1820000,
    status: "已完结",
    updateTime: "2026-06-15",
    latestChapter: "全200话",
    description: "这是一个普通又不普通的中国家庭日常。严厉的妈妈、憨厚的爸爸、调皮的儿子、活泼的女儿，每天上演着令人捧腹的搞笑故事。治愈你的不开心！",
    tags: ["国漫", "搞笑", "日常", "家庭"],
    chapters: [
      { num: 200, title: "幸福的样子（完结）", date: "2026-06-15" },
      { num: 199, title: "儿子的成长", date: "2026-06-12" },
      { num: 198, title: "全家旅行记", date: "2026-06-09" },
      { num: 197, title: "妈妈生病了", date: "2026-06-06" },
      { num: 196, title: "女儿的心事", date: "2026-06-03" },
    ],
  },
  {
    id: 5,
    title: "暗夜追踪者",
    author: "黑泽明介",
    category: "riman",
    subCategory: "xuanyi",
    cover: "https://readdy.ai/api/search-image?query=A%20dark%20mystery%20manga%20cover%20featuring%20a%20detective%20in%20a%20trench%20coat%20standing%20in%20a%20rainy%20alley%20at%20night%2C%20dramatic%20lighting%20from%20a%20streetlamp%2C%20silhouette%20of%20a%20suspect%20in%20the%20distance%2C%20noir%20atmosphere%2C%20muted%20dark%20colors%20with%20pops%20of%20warm%20yellow%20light%2C%20Japanese%20manga%20art%20style%2C%20suspenseful%20and%20moody%20composition&width=400&height=560&seq=comic-cover-05&orientation=portrait",
    rating: 9.6,
    views: 3120000,
    status: "连载中",
    updateTime: "3小时前",
    latestChapter: "第203话",
    description: "城市里连续发生离奇失踪案，警视厅王牌刑警田中所面临的不仅是狡猾的罪犯，还有一个隐藏在暗处的庞大组织。真相远比想象中更加黑暗...",
    tags: ["日漫", "悬疑", "推理", "犯罪"],
    chapters: [
      { num: 203, title: "真凶浮现", date: "2026-08-04" },
      { num: 202, title: "关键线索", date: "2026-08-01" },
      { num: 201, title: "新的牺牲者", date: "2026-07-30" },
      { num: 200, title: "逼近真相", date: "2026-07-27" },
      { num: 199, title: "暗号解读", date: "2026-07-24" },
    ],
  },
  {
    id: 6,
    title: "我的女友是九尾狐",
    author: "渡边花子",
    category: "riman",
    subCategory: "lianai",
    cover: "https://readdy.ai/api/search-image?query=A%20fantasy%20romance%20manga%20cover%20showing%20a%20beautiful%20girl%20with%20nine%20fox%20tails%20in%20a%20Japanese%20school%20uniform%2C%20cherry%20blossoms%20falling%2C%20magical%20sparkles%20around%20her%2C%20a%20shy%20boy%20beside%20her%2C%20soft%20pink%20and%20white%20color%20palette%2C%20Japanese%20manga%20art%20style%2C%20romantic%20and%20magical%20atmosphere%2C%20clean%20composition&width=400&height=560&seq=comic-cover-06&orientation=portrait",
    rating: 9.4,
    views: 1650000,
    status: "连载中",
    updateTime: "8小时前",
    latestChapter: "第112话",
    description: "平凡高中生佐藤遇到了一个神秘的美少女转学生，却发现她竟然是传说中的九尾狐！一段跨越种族和人妖界限的奇幻恋爱故事就此展开。",
    tags: ["日漫", "恋爱", "奇幻", "校园"],
    chapters: [
      { num: 112, title: "月光下的告白", date: "2026-08-04" },
      { num: 111, title: "她的秘密", date: "2026-08-02" },
      { num: 110, title: "祭典之夜", date: "2026-07-30" },
      { num: 109, title: "妖怪来袭", date: "2026-07-27" },
      { num: 108, title: "第一次约会", date: "2026-07-24" },
    ],
  },
  {
    id: 7,
    title: "武神天下",
    author: "萧天",
    category: "guoman",
    subCategory: "rexue",
    cover: "https://readdy.ai/api/search-image?query=A%20Chinese%20martial%20arts%20manhua%20cover%20showing%20a%20powerful%20warrior%20with%20flowing%20robes%20and%20a%20fierce%20expression%2C%20surrounded%20by%20energy%20waves%2C%20ancient%20Chinese%20temple%20in%20background%2C%20dramatic%20dynamic%20pose%2C%20golden%20and%20crimson%20color%20scheme%2C%20epic%20heroic%20atmosphere%2C%20clean%20powerful%20composition%2C%20high%20quality%20illustration&width=400&height=560&seq=comic-cover-07&orientation=portrait",
    rating: 9.8,
    views: 4580000,
    status: "连载中",
    updateTime: "刚刚",
    latestChapter: "第320话",
    description: "少年萧凡，身怀绝世武魂却无法觉醒，被世人嘲笑为废物。直到那一天，远古神物认主，他的命运从此改变。武神之路，唯我独尊！",
    tags: ["国漫", "热血", "玄幻", "逆袭"],
    chapters: [
      { num: 320, title: "神域降临", date: "2026-08-04" },
      { num: 319, title: "终极对决", date: "2026-08-02" },
      { num: 318, title: "武魂觉醒", date: "2026-07-31" },
      { num: 317, title: "惊天秘密", date: "2026-07-28" },
      { num: 316, title: "突破极限", date: "2026-07-25" },
    ],
  },
  {
    id: 8,
    title: "邻居家的秘密",
    author: "李恩智",
    category: "hanman",
    subCategory: "xuanyi",
    cover: "https://readdy.ai/api/search-image?query=A%20thriller%20manhwa%20cover%20showing%20a%20woman%20peeking%20through%20half-closed%20curtains%20with%20a%20shocked%20expression%2C%20a%20mysterious%20shadow%20visible%20in%20the%20neighbors%20window%2C%20tense%20atmosphere%2C%20muted%20dark%20colors%20with%20cool%20undertones%2C%20Korean%20webtoon%20style%2C%20suspenseful%20composition%2C%20urban%20apartment%20setting%20at%20night&width=400&height=560&seq=comic-cover-08&orientation=portrait",
    rating: 9.2,
    views: 756000,
    status: "连载中",
    updateTime: "12小时前",
    latestChapter: "第43话",
    description: "搬进新公寓的她，每晚都能听到隔壁传来的奇怪声音。好奇心驱使下，她开始暗中观察那位神秘邻居，却发现了令人毛骨悚然的真相...",
    tags: ["韩漫", "悬疑", "惊悚", "都市"],
    chapters: [
      { num: 43, title: "地下室的秘密", date: "2026-08-03" },
      { num: 42, title: "深夜访客", date: "2026-07-31" },
      { num: 41, title: "警察调查", date: "2026-07-29" },
      { num: 40, title: "失踪的房客", date: "2026-07-26" },
      { num: 39, title: "不该打开的门", date: "2026-07-23" },
    ],
  },
  {
    id: 9,
    title: "美食猎人",
    author: "松本一郎",
    category: "riman",
    subCategory: "gaoxiao",
    cover: "https://readdy.ai/api/search-image?query=A%20fun%20food-themed%20manga%20cover%20showing%20a%20cheerful%20young%20chef%20holding%20a%20giant%20fork%20and%20knife%2C%20surrounded%20by%20exaggerated%20delicious%20dishes%20floating%20around%2C%20bright%20warm%20colors%20of%20orange%20and%20yellow%2C%20Japanese%20manga%20art%20style%2C%20mouthwatering%20food%20illustrations%2C%20energetic%20and%20playful%20atmosphere%2C%20clean%20composition&width=400&height=560&seq=comic-cover-09&orientation=portrait",
    rating: 9.0,
    views: 890000,
    status: "已完结",
    updateTime: "2026-05-20",
    latestChapter: "全156话",
    description: "天才少年厨师为了寻找传说中的终极食材，踏上了环游世界的美食冒险之旅。每一道菜背后都有一个温暖人心的故事，让你笑着流泪！",
    tags: ["日漫", "搞笑", "美食", "冒险"],
    chapters: [
      { num: 156, title: "终极料理（完结）", date: "2026-05-20" },
      { num: 155, title: "最后的食材", date: "2026-05-17" },
      { num: 154, title: "味觉对决", date: "2026-05-14" },
      { num: 153, title: "传说中的厨房", date: "2026-05-11" },
      { num: 152, title: "师傅的教诲", date: "2026-05-08" },
    ],
  },
  {
    id: 10,
    title: "天庭快递员",
    author: "周末",
    category: "guoman",
    subCategory: "gaoxiao",
    cover: "https://readdy.ai/api/search-image?query=A%20funny%20Chinese%20manhua%20cover%20showing%20a%20young%20delivery%20guy%20riding%20a%20scooter%20in%20a%20fantasy%20heavenly%20palace%20setting%2C%20celestial%20beings%20receiving%20packages%2C%20bright%20vibrant%20colors%2C%20humorous%20expression%20on%20the%20protagonist%2C%20mix%20of%20modern%20and%20ancient%20elements%2C%20playful%20atmosphere%2C%20clean%20composition%2C%20cartoonish%20style&width=400&height=560&seq=comic-cover-10&orientation=portrait",
    rating: 9.3,
    views: 1340000,
    status: "连载中",
    updateTime: "6小时前",
    latestChapter: "第78话",
    description: "在现代送外卖的普通青年，意外被天庭录用为专属快递员。从此，玉帝的蟠桃、太上老君的仙丹、嫦娥的月饼...他要为各路神仙送快递！",
    tags: ["国漫", "搞笑", "奇幻", "日常"],
    chapters: [
      { num: 78, title: "王母娘娘的生日", date: "2026-08-04" },
      { num: 77, title: "紧急订单", date: "2026-08-02" },
      { num: 76, title: "二郎神的包裹", date: "2026-07-30" },
      { num: 75, title: "快递差评风波", date: "2026-07-27" },
      { num: 74, title: "哪吒的恶作剧", date: "2026-07-24" },
    ],
  },
  {
    id: 11,
    title: "猎魔人传说",
    author: "金贤民",
    category: "hanman",
    subCategory: "rexue",
    cover: "https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20manhwa%20cover%20showing%20a%20demon%20hunter%20with%20silver%20hair%20wielding%20a%20glowing%20weapon%2C%20battle-scarred%20armor%2C%20demonic%20creatures%20lurking%20in%20the%20shadows%2C%20gothic%20cathedral%20background%2C%20moody%20lighting%20with%20crimson%20and%20silver%20accents%2C%20Korean%20webtoon%20style%2C%20epic%20and%20intense%20atmosphere&width=400&height=560&seq=comic-cover-11&orientation=portrait",
    rating: 9.5,
    views: 2100000,
    status: "连载中",
    updateTime: "4小时前",
    latestChapter: "第145话",
    description: "在妖魔横行的世界里，猎魔人是人类最后的希望。少年凯在目睹家人被魔物杀害后，毅然踏上猎魔之路，誓要杀尽天下妖魔，守护人间。",
    tags: ["韩漫", "热血", "奇幻", "战斗"],
    chapters: [
      { num: 145, title: "魔王降临", date: "2026-08-04" },
      { num: 144, title: "猎魔人的荣耀", date: "2026-08-01" },
      { num: 143, title: "最后的试炼", date: "2026-07-30" },
      { num: 142, title: "失落的圣物", date: "2026-07-27" },
      { num: 141, title: "黑暗势力", date: "2026-07-24" },
    ],
  },
  {
    id: 12,
    title: "恋爱频率",
    author: "高桥美咲",
    category: "riman",
    subCategory: "lianai",
    cover: "https://readdy.ai/api/search-image?query=A%20sweet%20shojo%20manga%20cover%20showing%20a%20cute%20high%20school%20couple%20sharing%20earphones%20listening%20to%20music%20together%2C%20cherry%20blossoms%20and%20musical%20notes%20floating%20around%2C%20soft%20pastel%20pink%20and%20mint%20color%20palette%2C%20Japanese%20manga%20art%20style%2C%20gentle%20and%20romantic%20atmosphere%2C%20clean%20innocent%20composition&width=400&height=560&seq=comic-cover-12&orientation=portrait",
    rating: 9.1,
    views: 720000,
    status: "已完结",
    updateTime: "2026-04-30",
    latestChapter: "全98话",
    description: "因为一首歌，两个素不相识的高中生相遇了。音乐社的日常、学园祭的舞台、毕业前的告白...音符串联起的青春恋曲，甜到心坎里。",
    tags: ["日漫", "恋爱", "校园", "音乐"],
    chapters: [
      { num: 98, title: "我们的歌（完结）", date: "2026-04-30" },
      { num: 97, title: "毕业典礼", date: "2026-04-27" },
      { num: 96, title: "最后的演出", date: "2026-04-24" },
      { num: 95, title: "梦想的方向", date: "2026-04-21" },
      { num: 94, title: "一起的未来", date: "2026-04-18" },
    ],
  },
];

export const getComicsByCategory = (categorySlug: string) => {
  if (categorySlug === "all") return comics;
  return comics.filter(
    (c) => c.category === categorySlug || c.subCategory === categorySlug
  );
};

export const getComicById = (id: number) => {
  return comics.find((c) => c.id === id);
};

export const getLatestComics = (limit: number = 6) => {
  return [...comics]
    .sort((a, b) => new Date(b.chapters[0].date).getTime() - new Date(a.chapters[0].date).getTime())
    .slice(0, limit);
};

export const getTopComics = (limit: number = 10) => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};

export const getRecommendedComics = (currentId: number, limit: number = 4) => {
  return comics.filter((c) => c.id !== currentId).slice(0, limit);
};